import type { ProductLogoMediumProps } from "../types";

export function ProductLogoMediumNetworks({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        d="M445.923 385.608C451.662 388.921 453.629 396.26 450.315 402C447.001 407.739 439.662 409.706 433.923 406.392L413.138 394.392C407.399 391.079 405.432 383.739 408.746 378C412.06 372.26 419.399 370.294 425.138 373.608L445.923 385.608Z"
        fill="#57D7D9"
      />
      <path
        d="M258.861 277.608C264.601 280.921 266.567 288.26 263.254 294C259.94 299.739 252.601 301.706 246.861 298.392L226.077 286.392C220.337 283.079 218.371 275.739 221.684 270C224.998 264.26 232.337 262.294 238.077 265.608L258.861 277.608Z"
        fill="#57D7D9"
      />
      <path
        d="M482.081 454.981C467.732 446.696 462.816 428.349 471.1 414C479.384 399.651 497.732 394.735 512.081 403.019C526.429 411.303 531.346 429.651 523.061 444C514.777 458.349 496.429 463.265 482.081 454.981Z"
        fill="white"
      />
      <path
        d="M159.919 268.981C145.57 260.696 140.654 242.349 148.938 228C157.223 213.651 175.57 208.735 189.919 217.019C204.268 225.303 209.184 243.651 200.9 258C192.616 272.349 174.268 277.265 159.919 268.981Z"
        fill="white"
      />
      <path
        d="M348.001 456C348.001 462.628 342.628 468 336.001 468C329.373 468 324.001 462.628 324.001 456V432C324.001 425.373 329.373 420 336.001 420C342.628 420 348.001 425.373 348.001 432V456Z"
        fill="#57D7D9"
      />
      <path
        d="M348.001 240C348.001 246.628 342.628 252 336.001 252C329.373 252 324.001 246.628 324.001 240V216C324.001 209.373 329.373 204 336.001 204C342.628 204 348.001 209.373 348.001 216V240Z"
        fill="#57D7D9"
      />
      <path
        d="M306.001 522C306.001 505.432 319.432 492 336.001 492C352.569 492 366.001 505.432 366.001 522C366.001 538.569 352.569 552 336.001 552C319.432 552 306.001 538.569 306.001 522Z"
        fill="white"
      />
      <path
        d="M306.001 150C306.001 133.432 319.432 120 336.001 120C352.569 120 366.001 133.432 366.001 150C366.001 166.569 352.569 180 336.001 180C319.432 180 306.001 166.569 306.001 150Z"
        fill="white"
      />
      <path
        d="M433.922 265.607C439.662 262.293 447.001 264.26 450.315 269.999C453.629 275.739 451.662 283.078 445.922 286.391L425.138 298.391C419.398 301.705 412.059 299.739 408.746 293.999C405.432 288.26 407.398 280.92 413.138 277.607L433.922 265.607Z"
        fill="#57D7D9"
      />
      <path
        d="M246.861 373.607C252.6 370.293 259.94 372.26 263.253 377.999C266.567 383.739 264.6 391.078 258.861 394.391L238.076 406.391C232.337 409.705 224.998 407.739 221.684 401.999C218.37 396.26 220.337 388.921 226.076 385.607L246.861 373.607Z"
        fill="#57D7D9"
      />
      <path
        d="M512.08 268.98C497.731 277.264 479.384 272.348 471.099 257.999C462.815 243.65 467.731 225.303 482.08 217.018C496.429 208.734 514.777 213.65 523.061 227.999C531.345 242.348 526.429 260.696 512.08 268.98Z"
        fill="white"
      />
      <path
        d="M189.919 454.98C175.57 463.264 157.222 458.348 148.938 443.999C140.654 429.65 145.57 411.303 159.919 403.018C174.267 394.734 192.615 399.65 200.899 413.999C209.184 428.348 204.267 446.696 189.919 454.98Z"
        fill="white"
      />
      <path
        d="M276 336C276 302.863 302.863 276 336 276C369.137 276 396 302.863 396 336C396 369.137 369.137 396 336 396C302.863 396 276 369.137 276 336Z"
        fill="white"
      />
      <path
        d="M162 318C162 311.373 167.373 306 174 306C180.627 306 186 311.373 186 318V354C186 360.627 180.627 366 174 366C167.373 366 162 360.627 162 354V318Z"
        fill="#57D7D9"
      />
      <path
        d="M485 318C485 311.373 490.373 306 497 306C503.627 306 509 311.373 509 318V354C509 360.627 503.627 366 497 366C490.373 366 485 360.627 485 354V318Z"
        fill="#57D7D9"
      />
      <path
        d="M264.338 176.745C270.078 173.431 277.417 175.397 280.731 181.137C284.044 186.876 282.078 194.216 276.338 197.529L245.162 215.529C239.422 218.843 232.083 216.876 228.769 211.137C225.456 205.397 227.422 198.058 233.162 194.745L264.338 176.745Z"
        fill="#57D7D9"
      />
      <path
        d="M425.838 456.471C431.578 453.157 438.917 455.124 442.231 460.863C445.544 466.603 443.578 473.942 437.838 477.255L406.661 495.255C400.922 498.569 393.583 496.603 390.269 490.863C386.956 485.124 388.922 477.785 394.662 474.471L425.838 456.471Z"
        fill="#57D7D9"
      />
      <path
        d="M437.839 194.745C443.579 198.058 445.545 205.397 442.232 211.137C438.918 216.876 431.579 218.843 425.839 215.529L394.662 197.529C388.923 194.216 386.956 186.876 390.27 181.137C393.584 175.397 400.923 173.431 406.662 176.745L437.839 194.745Z"
        fill="#57D7D9"
      />
      <path
        d="M276.339 474.471C282.079 477.785 284.045 485.124 280.732 490.863C277.418 496.603 270.079 498.569 264.339 495.255L233.162 477.255C227.423 473.942 225.456 466.603 228.77 460.863C232.084 455.124 239.423 453.157 245.162 456.471L276.339 474.471Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
